<template>
  <video
    autoplay
    loop
    playsinline
    crossorigin
    class="w-100"
    id="workout-video-loop"
  ></video>
</template>

<script>
import Hls from "hls.js";

export default {
  props: {
    streamUrl: String
  },
  mounted() {
    const videoElement = document.getElementById("workout-video-loop");

    if (videoElement.canPlayType("application/vnd.apple.mpegURL")) {
      let source = document.createElement("source");
      source.src = this.streamUrl;
      source.type = "application/vnd.apple.mpegURL";
      videoElement.appendChild(source);
    } else if (Hls.isSupported()) {
      var config = {
        autoStartLoad: false
      };

      const hls = new Hls(config);
      hls.loadSource(this.streamUrl);
      hls.on(Hls.Events.MANIFEST_PARSED, function() {
        hls.startLoad();
      });

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        const availableQualities = hls.levels.map(l => l.height).reverse();
        // this.playerOptions.quality = {
        //   default: 0,
        //   options: [0, ...availableQualities],
        //   forced: true,
        //   onChange: e => updateQuality(e)
        // };
        // this.initPlayer();
      });

      // const updateQuality = newQuality => {
      //   if (newQuality === 0) {
      //     hls.currentLevel = -1;
      //   } else {
      //     hls.levels.forEach((level, levelIndex) => {
      //       if (level.height === newQuality) {
      //         hls.currentLevel = levelIndex;
      //       }
      //     });
      //   }
      // };

      hls.attachMedia(videoElement);
    }
  }
};
</script>
